import { Flex, Modal, Typography } from "antd"

import ButtonComponent from "../../../../Components/Button"
import Icon from "../../../../Icon"
import { request } from "../../../../Services/Api"

const { Title, Text, Link } = Typography

const saveInviteChoiceRequest = (data) => {
  return request.api.post("/integrations/adyen/save-invite-choice/", data)
}

const AdyenConnectionSuccessModal = ({ opened, close }) => {
  const handleInviteLater = () => {
    close()
    saveInviteChoiceRequest({ choice: "invite_later" })
  }

  const handleAlreadyInvited = () => {
    close()
    saveInviteChoiceRequest({ choice: "already_invited" })
  }
  return (
    <Modal
      open={opened}
      onCancel={close}
      classNames={{ content: "clear-bg" }}
      title={<Icon type={"success_modal"} />}
      closeIcon={<Icon type={"cross_small"} />}
      width={442}
      footer={
        <Flex gap={12} justify="flex-end">
          <ButtonComponent size="large" onClick={handleInviteLater}>
            Invite later
          </ButtonComponent>
          <ButtonComponent size="large" type="primary" onClick={handleAlreadyInvited}>
            Already invited
          </ButtonComponent>
        </Flex>
      }
    >
      <Flex vertical gap={8}>
        <Title level={4} style={{ marginBottom: 0, lineHeight: "24px", fontWeight: 600 }}>
          Connection Successful
        </Title>
        <Text type="secondary">
          <strong>Recommendation for best results:</strong> Transactions created before the
          integration is connected can’t be automatically refunded. To refund those earlier
          transactions, you’ll need to invite a Chargeback Support Manager to your Adyen account so
          we can help.
          <br />
          <br />
          If you'd like to invite a Support Manager, add{" "}
          <Link href="mailto:support@chargeback.io">support@chargeback.io</Link> as a partner.
        </Text>
      </Flex>
    </Modal>
  )
}

export default AdyenConnectionSuccessModal
